import { useLocation, useNavigate } from "react-router-dom";
import { useState } from "react";
import { Box, Card, CardContent, Typography, Button, Radio, RadioGroup, FormControlLabel,TextField } from "@mui/material";
import { isAnswerCorrect } from "../components/semanticChecker"; // adjust path
import Confetti from "react-confetti";
import { useWindowSize } from "react-use";

const TakeQuiz = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const { questions, topic } = location.state || {};
   const { width, height } = useWindowSize();

    const [userAnswers, setUserAnswers] = useState({});
const [answerFeedback, setAnswerFeedback] = useState({}); // { index: true/false }

    const [submitted, setSubmitted] = useState(false);
    const [score, setScore] = useState(null);

    if (!questions) {
        return (
            <Typography variant="h5" color="error" sx={{ textAlign: "center", mt: 4 }}>
                No quiz found
            </Typography>
        );
    }

    const handleAnswerChange = (questionIndex, answer) => {
        setUserAnswers(prev => ({
            ...prev,
            [questionIndex]: answer,
        }));
    };

const handleSubmit = async () => {
    let correctAnswers = 0;
    let feedback = {};

    for (let index = 0; index < questions.length; index++) {
        const q = questions[index];
        const userAns = (userAnswers[index] || "").trim();
        const correctAns = (q.answer || "").trim();

        if (q.options && q.options.length > 0) {
            const isCorrect = userAns.toLowerCase() === correctAns.toLowerCase();
            if (isCorrect) correctAnswers++;
            feedback[index] = isCorrect;
        } else {
            const isCorrect = await isAnswerCorrect(userAns, correctAns);
            if (isCorrect) correctAnswers++;
            feedback[index] = isCorrect;
        }
    }

    const totalQuestions = questions.length;
    const calculatedScore = ((correctAnswers / totalQuestions) * 100).toFixed(2);
    setScore(calculatedScore);
    setSubmitted(true);
    setAnswerFeedback(feedback); // 👈 store correctness per structured answer
};


    const handleRetake = () => {
        setUserAnswers({});
        setSubmitted(false);
        setScore(null);
    };

    return (
        <Box sx={{ maxWidth: "700px", margin: "auto", mt: 4, p: 3, position: "relative" }}>
            <Typography variant="h4" sx={{ fontWeight: "bold", textAlign: "center", mb: 3 }}>
                {topic || "Quiz"}
            </Typography>

            {/*submitted && <Confetti width={width} height={height} numberOfPieces={300} />*/}
{submitted && score >= 80 && <Confetti width={width} height={height} numberOfPieces={300} />}


            {questions.map((q, index) => (
                <Card key={index} sx={{ mb: 3, boxShadow: 3 }}>
                    <CardContent>
                        <Typography variant="h6" sx={{ mb: 2 }}>
                            {index + 1}. {q.question}
                        </Typography>

                        {q.options && q.options.length > 0 ? (
                            <RadioGroup
                                value={userAnswers[index] || ""}
                                onChange={(e) => handleAnswerChange(index, e.target.value)}
                            >
                                {q.options.map((option, i) => {
                                    const isCorrect = q.answer === option;
                                    const isUserChoice = userAnswers[index] === option;
                                    const isWrongChoice = isUserChoice && !isCorrect;

                                    return (
                                        <FormControlLabel
                                            key={i}
                                            value={option}
                                            control={<Radio disabled={submitted} />}
                                            label={option}
                                            sx={{
                                                backgroundColor: submitted
                                                    ? isCorrect
                                                        ? "#c8e6c9"
                                                        : isWrongChoice
                                                        ? "#ffcdd2"
                                                        : "transparent"
                                                    : "transparent",
                                                borderRadius: "5px",
                                                padding: "5px",
                                                mt: 1,
                                            }}
                                        />
                                    );
                                })}
                            </RadioGroup>
                        ) : (
                            <>
                                <TextField
                                    fullWidth
                                    variant="outlined"
                                    label="Your Answer"
                                    value={userAnswers[index] || ""}
                                    onChange={(e) => handleAnswerChange(index, e.target.value)}
                                    disabled={submitted}
                                    sx={{
                                        mt: 1,
                                        backgroundColor: submitted
                                            ? answerFeedback[index] === true
                                                ? "#c8e6c9"
                                                : "#ffcdd2"
                                            : "transparent",
                                        borderRadius: "5px",
                                    }}
                                />

                                {submitted && (
                                    <Typography
                                        variant="body2"
                                        sx={{
                                            mt: 1,
                                            color: answerFeedback[index] ? "green" : "red",
                                            fontWeight: "bold",
                                        }}
                                    >
                                        {answerFeedback[index] ? "Correct" : "Incorrect"} � Correct Answer: {q.answer}
                                    </Typography>
                                )}
                            </>
                        )}
                    </CardContent>
                </Card>
            ))}

            {!submitted ? (
                <Button
                    variant="contained"
                    color="primary"
                    fullWidth
                    onClick={handleSubmit}
                    sx={{ fontWeight: "bold", mt: 2 }}
                >
                    Submit Quiz
                </Button>
            ) : (
                <Box sx={{ textAlign: "center", mt: 3 }}>
                    <Typography variant="h5" sx={{ fontWeight: "bold", mb: 2 }}>
                        Your Score: {score}%
                    </Typography>
                    <Button
                        variant="outlined"
                        color="info"
                        onClick={handleRetake}
                        sx={{ mr: 2, fontWeight: "bold" }}
                    >
                        Retake Quiz
                    </Button>
                    <Button
                        variant="contained"
                        color="secondary"
                        onClick={() => navigate("/")}
                        sx={{ fontWeight: "bold" }}
                    >
                        Back to Home
                    </Button>
                </Box>
            )}
        </Box>
    );
};

export default TakeQuiz;